const actions = {

  HOST_LISTING_CONFIGURATION_BEGIN: 'HOST_LISTING_CONFIGURATION_BEGIN',
  HOST_LISTING_CONFIGURATION_SUCCESS: 'HOST_LISTING_CONFIGURATION_SUCCESS',
  HOST_LISTING_CONFIGURATION_ERR: 'HOST_LISTING_CONFIGURATION_ERR',

  HOST_LISTING_CONFIGURATION_UPDATE_BEGIN: 'HOST_LISTING_CONFIGURATION_UPDATE_BEGIN',
  HOST_LISTING_CONFIGURATION_UPDATE_SUCCESS: 'HOST_LISTING_CONFIGURATION_UPDATE_SUCCESS',
  HOST_LISTING_CONFIGURATION_UPDATE_ERR: 'HOST_LISTING_CONFIGURATION_UPDATE_ERR',

  hostListingConfigurationBegin: () => {
    return {
      type: actions.HOST_LISTING_CONFIGURATION_BEGIN,
    };
  },

  hostListingConfigurationSuccess: (data) => {
    return {
      type: actions.HOST_LISTING_CONFIGURATION_SUCCESS,
      data,
    };
  },

  hostListingConfigurationErr: (err) => {
    return {
      type: actions.HOST_LISTING_CONFIGURATION_ERR,
      err,
    };
  },
  hostListingConfigurationUpdateBegin: () => { 
    return { 
      type: actions.HOST_LISTING_CONFIGURATION_UPDATE_BEGIN 
    };
  },
  hostListingConfigurationUpdateSuccess: (data) => { 
    return { 
      type: actions.HOST_LISTING_CONFIGURATION_UPDATE_SUCCESS,
      data,
    };
  },
  hostListingConfigurationUpdateErr: (err) => { 
    return { 
      type: actions.HOST_LISTING_CONFIGURATION_UPDATE_ERR,
      err, 
    };
  },

};

export default actions;